import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import Dialog from '../../common/Dialog';

const youtubeRegex = /^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#&?]*).*$/;

class YoutubeDialog extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.node,
    onSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: null,
  };

  state = {
    link: '',
  };

  onLinkChange = event => {
    this.setState({ link: event.target.value });
  };

  onDialogOpen = () => {
    this.setState({ link: '' });
  };

  onSubmit = () => {
    const matches = this.state.link.match(youtubeRegex);
    if (matches) {
      this.props.onSubmit(matches[1]);
    }
  };

  render() {
    const { title } = this.props;
    const { link } = this.state;

    const matches = link.match(youtubeRegex);

    const valid = !!link && !!matches;
    const invalid = !!link && !matches;

    return (
      <Dialog
        id={this.props.id}
        title={
          title || (
            <FormattedMessage
              id="youtube-dialog-title"
              defaultMessage="Syötä YouTube-linkki"
            />
          )
        }
        onOpen={this.onDialogOpen}
        footer={
          <div className="modal-footer pt-0 mt-3">
            <div className="d-flex flex-column w-100">
              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-neutral"
                  data-dismiss="modal"
                >
                  <FormattedMessage
                    id="generic-dialog-cancel"
                    defaultMessage="Peruuta"
                  />
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onSubmit}
                  data-dismiss="modal"
                  disabled={!link || invalid}
                >
                  <FormattedMessage
                    id="generic-dialog-confirm"
                    defaultMessage="Vahvista"
                  />
                </button>
              </div>
            </div>
          </div>
        }
      >
        <div className="form-group">
          <input
            className={classNames('form-control', {
              'is-valid': valid,
              'is-invalid': invalid,
            })}
            type="text"
            value={link}
            placeholder="https://www.youtube.com/watch?v=..."
            onChange={this.onLinkChange}
          />

          {valid && (
            <div className="valid-feedback">
              <FormattedMessage
                id="youtube-dialog-shortcode"
                defaultMessage="Videon lyhytkoodi: {shortcode}"
                values={{
                  shortcode: matches[1],
                }}
              />
            </div>
          )}

          {invalid && (
            <div className="invalid-feedback">
              <FormattedMessage
                id="youtube-dialog-error"
                defaultMessage="Virheellinen YouTube-linkki"
              />
            </div>
          )}
        </div>
      </Dialog>
    );
  }
}

export default YoutubeDialog;
